'use client'

import VisitDraftSessionCleanup from '../../components/visits/VisitDraftSessionCleanup'

import { HappyStytchB2B } from '@/packages/auth/components/stytch-b2b'
import { StytchB2BClientProvider } from '@/packages/auth/components/stytch-b2b-client-provider'
import { IFrameRedirect } from '@web/app/components/auth/IFrameRedirect'

export default function LoginPage() {
  return (
    <div className='mt-20 flex w-full justify-center'>
      <StytchB2BClientProvider>
        <VisitDraftSessionCleanup />
        <IFrameRedirect />
        <HappyStytchB2B />
      </StytchB2BClientProvider>
    </div>
  )
}
